module.exports = __webpack_public_path__ + "static/media/featured-img4.18412d78.jpg";